import React, {useState, useEffect, useContext} from 'react';
import { Typography, Grid, Stack, Box } from '@mui/material';
import Container from '@mui/material/Container';
import Image from 'next/image';
import About from '../../public/images/about.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import parse from 'html-react-parser';
import { useAppContext } from '../../AppContext';
import { useTheme } from '@mui/material/styles';

function TypeTwo() {
    const theme = useTheme();
  const { url, themeData, siteData,  themeLoading, siteLoading, themeError, siteError, changeUrl, updateThemeData, updateSiteData } = useAppContext();
    const [themeCss, setThemeCss] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
        let custom_css = themeData && themeData ? JSON.parse(themeData && themeData.custom_css): null;
        setThemeCss(custom_css)
        setLoading(false)
    }, [themeData]);

    useEffect(()=>{
        AOS.init();
        AOS.refresh();
    }, []);
    
    const aboutContainer = {
        py:3,
        mb:4,
        '& h2':{
            fontFamily: themeCss && themeCss ? (themeCss.theme_primary_font).replace("+"," ") : '',
            fontSize:35,
            fontWeight:700,
            textTransform:'capitalize',
            color: `${theme.palette.primary.title} !important`,
        },
        '& p':{
            fontFamily: themeCss && themeCss ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize:16,
            fontWeight:300,
            color: `${theme.palette.primary.location} !important`,
            lineHeight:`25px`,
            textTransform:'capitalize',
        }
    }

    const aboutImageContainer = {
        '& img':{
            width:'100%'
        }
    }

  return (
    <Typography component="div" sx={aboutContainer}>
        <Container maxWidth="lg">
            <Typography variant="h2" sx={{pb:6, textAlign:'center'}}>About Us</Typography>
            <Grid container spacing={{md:10, sm:5, xs:5}}>
                {siteData&&siteData.aboutPageSections.map((item)=>(
                    <>
                    {item.format_type == 1 ?(
                        <>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} data-aos="fade-up" data-aos-duration="1000">
                            <Typography variant="h2" sx={{md:{mb:5, sm:1, xs:1}}}>{item.title ? item.title : ''}</Typography>
                            <Typography variant="p">{item.content ? parse(item.content) : ''}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={aboutImageContainer} data-aos="fade-up" data-aos-duration="1000">
                                <Image 
                                src={item.img_path ? item.img_path : About} 
                                alt="..." 
                                width={'100'} 
                                height={'400'}
                                sizes="(max-width: 325px) 100vw"
                                style={{objectFit: "contain"}}	
                            />
                            </Grid>
                        </>
                    ):(
                        <>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={aboutImageContainer} data-aos="fade-up" data-aos-duration="1000">
                                <Typography variant="h2" sx={{md:{mb:5, sm:1, xs:1}}} className="mobileMode">{item.title ? item.title : ''}</Typography>
                                <Image 
                                src={item.img_path ? item.img_path : About} 
                                alt="..." 
                                width={'100'} 
                                height={'400'}
                                sizes="(max-width: 325px) 100vw"
                                style={{objectFit: "contain"}}	
                            />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} data-aos="fade-up" data-aos-duration="1000">
                                <Typography variant="h2" sx={{md:{mb:5, sm:1, xs:1}}} className="desktopMode">{item.title ? item.title : ''}</Typography>
                                <Typography variant="p">{item.content ? parse(item.content) : ''}</Typography>
                            </Grid>                            
                        </>
                    )}
                    </>
                ))}
            </Grid>
        </Container>
    </Typography>
  )
}

export default TypeTwo